import { DomUtils } from "@tento-ui/dom";
import { Hotkeys } from "@tento-ui/hotkeys";
import type {
  BlogIndexRoute,
  BlogPage,
} from "../blog-variant";
import "@tento-ui/brand/blog/blog-bear-list-view";
import "@tento-ui/brand/blog/blog-bear-pagelet";
import { BlogBearListView } from "@tento-ui/brand/blog/blog-bear-list-view";
import { BlogBearPagelet } from "@tento-ui/brand/blog/blog-bear-pagelet";

let $list: Option<BlogBearListView> = null;

export const bearRoute: BlogIndexRoute = {
  make(props: BlogPage.Props, delegate: BlogPage.Delegate): HTMLElement {
    $list = BlogBearListView.makeWith(makeListProps(props, delegate));
    return BlogBearPagelet.makeWith({
      title: makeTitle(),
      search: makeSearch(delegate.onSearch),
      list: $list,
    });
  },
  bind(pagelet: HTMLElement, props: BlogPage.Props, delegate: BlogPage.Delegate): HTMLElement {
    $list?.bind(makeListProps(props, delegate));
    return pagelet;
  },
};

function makeListProps(
  props: BlogPage.Props,
  delegate: BlogPage.Delegate,
): BlogBearListView.Props {
  return {
    posts: props.posts,
    displayCount: props.displayCount,
    searchQuery: props.searchQuery,
    onSeeMore: delegate.onSeeMore,
    onCardClick: delegate.onCardClick,
  };
}

function makeTitle(): HTMLElement {
  const $title = document.createElement("h1");
  $title.className = "hero-title";
  $title.textContent = "Blog";
  return $title;
}

function makeSearch(onSearch: (query: string) => void): HTMLElement {
  const $input = document.createElement("input");
  $input.className = "search-input";
  $input.type = "text";
  $input.placeholder = "Search...";
  $input.assignStyles({
    width: "100%",
    maxWidth: "720px",
    padding: "7px 10px",
    backgroundColor: "var(--bg)",
    border: "1px solid #cfcfcf",
    borderRadius: "0px",
    outline: "none",
    fontFamily: "inherit",
    boxSizing: "border-box",
  });

  $input.addEventListener("input", () => {
    onSearch($input.value);
  });
  $input.onkeydown = $input.onkeyup = (e: KeyboardEvent) => {
    const hotkey = DomUtils.hotkeyIdentifier(e);
    if (!hotkey) return;
    if (Hotkeys.allowedHotkeyInEditor(hotkey)) return;
    if (Hotkeys.shouldPreventDefault(hotkey)) e.preventDefault();
    e.stopPropagation();
  };

  return $input;
}
